/**
 * Formatting utilities for action summary financial values and durations.
 * @module features/squad-planning/utils/formatActionValue
 */

/** Em dash for missing/null values */
export const EM_DASH = "\u2014";

/**
 * Formats a number as a short financial value with euro sign.
 * @param value - The numeric value
 * @returns Formatted string (e.g. "€1.5M", "€200K") or em dash
 */
export function formatEuroShort(value: number | null): string {
  if (value == null) return EM_DASH;
  const abs = Math.abs(value);
  if (abs >= 1_000_000) return `\u20AC${(value / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `\u20AC${(value / 1_000).toFixed(0)}K`;
  return `\u20AC${value}`;
}

/**
 * Formats duration in months as a short string.
 * @param months - Duration in months
 * @returns Formatted string (e.g. "5 mo", "2 yr") or em dash
 */
export function formatDurationShort(months: number | null): string {
  if (months == null) return EM_DASH;
  if (months >= 12 && months % 12 === 0) return `${months / 12} yr`;
  return `${months} mo`;
}
